export const CATEGORY_LOADING = 'CATEGORY_LOADING';
export const CATEGORIES_FULFILLED = 'CATEGORIES_FULFILLED';
export const CATEGORY_FULFILLED = 'CATEGORY_FULFILLED';
export const CATEGORIES_SEARCHED = 'CATEGORIES_SEARCHED';
export const CATEGORIES_SUM = 'CATEGORIES_SUM';
